import * as t from "react";
const r = (e) => /* @__PURE__ */ t.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("rect", { x: 1.42871, width: 26.264, height: 2.0203, rx: 1.01015, transform: "rotate(45 1.42871 0)" }), /* @__PURE__ */ t.createElement("rect", { x: 20, y: 1.42871, width: 26.264, height: 2.0203, rx: 1.01015, transform: "rotate(135 20 1.42871)" }));
export {
  r as S
};
